import React, { useEffect, useState } from 'react';

const AboutHeroSection = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setIsActive(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <section
      className={`about-hero${isActive ? ' is-active' : ''}`}
      aria-labelledby="about-hero-title"
    >
      <div className="about-hero-bg" aria-hidden="true">
        <img
          src={`${process.env.PUBLIC_URL}/about-hero-bg.png?v=2`}
          alt=""
          className="about-hero-bg-img"
        />
      </div>
      <div className="about-hero-overlay" aria-hidden="true" />

      <div className="about-hero-shell">
        <div className="about-hero-inner">
          <p className="about-hero-brand hero-reveal">About 360Coordinates</p>

          <h1 id="about-hero-title" className="about-hero-title hero-reveal hero-reveal-delay-1">
            India&apos;s Trusted
            <span className="about-hero-title-line">Property Platform</span>
          </h1>

          <p className="about-hero-subtitle hero-reveal hero-reveal-delay-2">
            Connecting buyers, sellers, and agents through verified listings, transparent
            deals, and smart technology — making every property journey confident and seamless.
          </p>

          <p className="about-hero-company hero-reveal hero-reveal-delay-3">
            Vedant Info Edge India LLP
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHeroSection;
